<template>
  <div class="transfer-content">
    <el-form :model="form" size="small" label-width="100px" label-position="left">
      <el-form-item label="产品类型">
        <el-select v-model="form.type">
          <el-option v-for="(p,i) in types" :key="i" :label="p" :value="p"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="填写方式">
        <el-radio v-model="radio" label="page">页面填写</el-radio>
        <el-radio v-model="radio" label="template">模板上传</el-radio>
      </el-form-item>
      <el-form-item label="下载模板" v-if="radio == 'template'">
        <a class="download-icon" :href="downloadTemp"  download="transferNumber.xlsx">点击下载</a>                
      </el-form-item>
      <el-form-item label="上传文件" v-if="radio == 'template'">
        <el-upload 
          action="#" 
          name="upload" 
          :limit="1" 
          list-type="text" 
          accept=".xlsx,.xls" 
          :on-change="handlePictureCardChange" 
          :on-remove="handleRemove" 
          :auto-upload="false"
          :file-list="fileList" 
          style="display: inline-block;">
            <el-button slot="trigger" size="mini">选取文件</el-button>
        </el-upload>
      </el-form-item>
      <el-table :data="form.items" border style="width: 650px;" v-if="radio == 'page'">
        <el-table-column label="订单号/箱号" width="250px">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.number" auto-complete="off" type="text" placeholder="订单号/箱号"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="转单号" width="250px">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.trackingNumber" auto-complete="off" type="text" placeholder="转单号"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="in_configs(41901)" size="small" type="danger" @click="delRow(scope.$index)" >删</el-button>
            <el-button v-if="in_configs(41902) && scope.$index === 0" size="small" type="primary" @click="addRow()">增加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-form-item style="margin-top: 50px;">
        <el-button size="small" type="primary" @click="submit()" >提   交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default() {
        return {
          items: [
            {"number": "", "trackingNumber": ""}
          ],
          type: 'UPS'
        }
      }
    }
  },
  data() {
    return{
      loading: true,
      types: [],
      radio: 'page',
      currentPage: 1,
      total: 0,
      types: [],
      downloadTemp: "../../../static/template/transferNumber.xlsx",
      fileList: []
    }
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 500);
    this.queryType();
  },
  methods: {
    addRow(){
       this.form.items.push({"number": "", "trackingNumber": ""}); 
    },
    delRow(i){
        if(i!=0){
            this.form.items.splice(i, 1);
        }        
    },
    
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.query();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.query();
    },
    queryType() {
      let _this = this;
      _this.$request1
        .get(
          '/lastMileExpress/type',
          {
            params: {},
            withCredentials: true
          }
        )
        .then(function(res) {
          //console.log(res);
          if (res.data.success) {
            _this.types = res.data.data.types;
            
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    checkForm(){
        let flag = true;
        let _this = this;
        if(this.fileList.length>0){
            return 'success';
        }
        
        if(_this.form.items.length == 0){
                return '请输入箱号';
            }
        for (let i = 0; i < _this.form.items.length; i++) {
            let e = _this.form.items[i];
            if(e.number.length<13){
                return '箱号或订单号不正确。';
            }
            if(e.trackingNumber.trim()==''){
                return '转单号不能为空。';
            }         
        }
        return 'success';
    },
    submit() {
      //提交订单
      var _this = this;
      let msg = _this.checkForm();
      if (msg != 'success') {
            _this.$message.error(msg);
            return;
      }
      var formData = new FormData();
      if(this.fileList.length>0){
        formData.append("file", this.fileList[0].raw);
      }
      formData.append("data", JSON.stringify(_this.form));

        this.$request1({
            url: '/lastMileExpress/transfer-number',
            method: "post",
            data: formData,
            withCredentials: true,
            headers: { "Content-Type": "multipart/form-data" }
        })
        .then(function(res) {
          //console.log(res);
          if (res.data.success) {
            _this.$message.success("提交成功");
            _this.form.items = [{"number": "", "trackingNumber": ""}];

            try {
                _this.$emit("closeTransferPanel");
            }catch(err){
                console.error(err);
            }

          } else {
            _this.$alert(res.data.message, "异常提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handlePictureCardChange(file, fileList) {
      //console.log(file, fileList);
      this.fileList.push(file);
    },
    handleRemove(file, fileList) {
      //console.log(file, fileList);
      this.fileList = [];
    }
  }
}
</script>

<style lang="scss" scoped>
.download-icon{
  font-size: 12px;
  color: #409EFF;
  &:hover{
    text-decoration: underline;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/orderOperation/TransferContent.vue